import { gql } from "@apollo/client";

// $searchCategory is optional: omitting it returns every category's tags grouped as
// [{category, tags: string[]}]; passing it (e.g. CreateMenuPage) narrows that same array down to
// just the matching category's group - the shape stays [{category, tags}], it's just filtered.
export const FETCH_TAG_LIST_QUERY = gql`
  query FETCH_TAG_LIST($start: Int!, $rows: Int!, $searchCategory: String) {
    authoring_getTagsList(
      pagination: { start: $start, rows: $rows }
      sort: DESC
      searchCategory: $searchCategory
    )
  }
`;

// Flat map of tag -> content count across all categories, e.g. { Country: 3, Fashion: 12 }
export const FETCH_CATEGORY_COUNTS_QUERY = gql`
  query FETCH_CATEGORY_COUNTS {
    authoring_categoryCounts
  }
`;

export const FETCH_TOPIC_LIST = gql`
  query fetchTopics {
    authoring_fetchTopics(type: "topics")
  }
`;
